module.exports = __webpack_public_path__ + "static/media/amex_black.bdcc87bf.png";